/**
 * Created by dmitry on 09.01.2025
 */

const ClickComponent = function (unit) { 
    UnitComponent.call(this, unit);
};

ClickComponent.prototype = Object.create(UnitComponent.prototype);
ClickComponent.prototype.constructor = ClickComponent;

ClickComponent.prototype.handleClick = function () {
    const data = this.unit.getData().click;

    if (data.windowOptions && data.windowOptions.window === OrdersWindow) {
        cleverapps.focusManager.display({
            focus: "openOrdersWindow",
            action: function (f) {
                new OrdersWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }

    return true;
};